import {
  GeoIpCountries,
  UpdateGeoIPCountriesRequest,
} from "@shared/types/common";
import { sleep } from "@shared/utils/tools.ts";

export default async (data?: object) => {
  const request = data as UpdateGeoIPCountriesRequest;
  await sleep(350);

  return {
    inProgress: false,
    geoIpRestrictionType: request.geoIpRestrictionType,
    geoIpRestrictionCountriesList: request.geoIpRestrictionCountriesList,
  } satisfies GeoIpCountries;
};
